import $ from 'jquery'
import Splide from '@splidejs/splide'
import {algoliaApiKey, algoliaAppId, locationSearchIndex, placeSearchIndex} from './variables';
import algoliasearch from 'algoliasearch/lite';
import {autocomplete, getAlgoliaResults} from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';

const { __ } = wp.i18n
const object = vnObject
const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
const searchIndex = searchClient.initIndex(placeSearchIndex)

const algolia_place_type_autocomplete = $('#algolia-place-type-autocomplete');

searchIndex
    .searchForFacetValues('placeType.name', '')
    .then(({ facetHits }) => { // Changement ici
        if (facetHits.length > 0) {
            let placeTypeHtml = '<ul class="aa-List js-place-type-list" style="display: none;">';
            facetHits.forEach((hit) => {
                placeTypeHtml += `<li class="aa-Item js-place-type-item" data-value="${hit.value}">${hit.value}</li>`;
            });
            placeTypeHtml += `</ul>`;
            algolia_place_type_autocomplete.after(placeTypeHtml);
        }
    })
    .catch((err) => {
        console.error(err);
    });


var footerSearchForm = $('.js-footer-search');
$('.js-footer-search-submit').on('click', function () {
    footerSearchForm.trigger('submit')
})

footerSearchForm.on('submit', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const formData = new FormData(footerSearchForm[0])
    formData.append('action', 'vn_search_place')
    formData.append('nonce', object.nonce)

    const $form = $(this)
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
            $form.addClass('sending')
        },
        processData: false,
        contentType: false,
        success: (res) => {
            $form.removeClass('sending')

            if (res.success && res.data.redirect) {
                window.location = res.data.redirect
            }
        },
    })
})


let footerLocationSearch

const checkFooterLocation = document.querySelector('.footer-search-location-handler')
if ( checkFooterLocation ) {
    footerLocationSearch = autocomplete({
        container: '.footer-search-location-handler',
        detachedMediaQuery: 'none',
        placeholder: __('Your location...', 'vn'),
        getSources() {
            return [{
                sourceId: 'locations',
                getItems({ query }) {
                    return getAlgoliaResults({
                        searchClient,
                        queries: [
                            {
                                indexName: locationSearchIndex,
                                query,
                            },
                        ],
                    });
                },
                templates: {
                    item({ item }) {
                        return `${item.title}`;
                    },
                },
                onSelect: function (event) {
                    event.setQuery( event.item.title );
                    $('.js-footer-city').val( event.item.title )
                    let latLng = event.item._geoloc;
                    if ( latLng ) {
                        $('.js-footer-latlng').val( parseFloat(latLng.lat) + ',' + parseFloat(latLng.lng) )
                    }
                },
            }];
        },
    });
}


$('.js-footer-place-type').on('click', function () {
    $('.js-place-type-list').slideDown()
})

$(document).on('click', '.js-place-type-item', function () {
    $('.js-footer-place-type').val($(this).data('value'));
    $('.js-place-type-list').slideUp();
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.js-footer-place-type-container').length) {
        $('.js-place-type-list').slideUp()
    }
});
